import axios from "axios";

const PYTHON_API_URL = "https://api.ai.raborisk.ai"
/**
 * Function to call the backend OpenAI API dynamically based on the use case
 * @param {string} useCase - The use case to determine the API behavior (e.g., "suggestControl", "generalChat").
 * @param {object} params - Parameters required for the selected use case. Example: { title, details } for suggestControl or { query } for generalChat.
 * @returns {Promise<string>} - Returns the AI-generated response.
 */
const callOpenAIAPI = async (title, description, threats = []) => {
  try {
    const threatTexts = threats.map(t => t.text ?? t);
    console.log("threats", threatTexts)
    const { data } = await axios.post(
      `${PYTHON_API_URL}/controls`,
      { title, description, threats: threatTexts },
      { headers: { "Content-Type": "application/json" } }
    );
    return data;
  } catch (err) {
    console.error("Error calling OpenAI API:", err);
    throw new Error("Failed to fetch AI response.");
  }
};


export const callOpenAIAPIChecklist = async (title, description) => {
    try {
      const { data } = await axios.post(
        `${PYTHON_API_URL}/control_checklist`,
        {title, description},                            // same as { ...params }
        { headers: { "Content-Type": "application/json" } }
      );
  
      // `data` itself is the answer
      return data;                         // no `.reply`
    } catch (err) {
      console.error("Error calling OpenAI API:", err);
      throw new Error("Failed to fetch AI response.");
    }
  };


  export const callOpenAIAPIRisks = async (Department_Name, Department_Definition) => {
    try {
      console.log("title ", Department_Name, "description ",Department_Definition )
      const { data } = await axios.post(
        `${PYTHON_API_URL}/department_risks`,
        {Department_Name, Department_Definition},     // same as { ...params }
        { headers: { "Content-Type": "application/json" } }
      );
  
      // `data` itself is the answer
      return data;                         // no `.reply`
    } catch (err) {
      console.error("Error calling OpenAI API:", err);
      throw new Error("Failed to fetch AI response.");
    }
  };

export default callOpenAIAPI;